
import axios from 'axios'
import Qs from 'qs'
import wx from 'weixin-js-sdk';

import {getServer} from '@/utils/share'
import {setStore, getStore, removeStore} from '@/config/mUtils'
import {APPID} from "@/service/getData";

import D from '@/wc-messagebox'
import Vue from 'vue'
Vue.use(D)

export const routeUrl = getServer().admin;


/**
 * 调用微信接口
 */
export const wxInitial = (callback) => {
  var isSuccess = false;
  var obj = { appid: APPID };
  obj.url = location.href.split('#')[0];

  try {
    if(isSuccess === false){
      var scenicKey =  getStore("scenicKey").scenicKey || '';
      var headers = {
        'Content-Type': 'application/x-www-form-urlencoded'
      };
      //if(scenicKey){
      //  headers = {
      //    'Content-Type': 'application/x-www-form-urlencoded',
      //    'scenicKey': scenicKey
      //  };
      //}

      axios.post( getServer().admin + "getsign.action", Qs.stringify(obj), {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      }).then(function (data) {
        isSuccess = true;
        // 响应成功回调
        wx.config({
          debug: false,
          appId: obj.appid,
          timestamp: data.data.timestamp,
          nonceStr: 'Wm3WZYTPz0wzccnW',
          signature: data.data.sign,
          jsApiList: [
            "getLocation", "openLocation", "onMenuShareTimeline", "onMenuShareAppMessage",'hideMenuItems',
            "onMenuShareQQ", "onMenuShareQZone", "previewImage","playVoice","onVoicePlayEnd",
            "pauseVoice","stopVoice","chooseWXPay","updateAppMessageShareData", "updateTimelineShareData",
          ],
          openTagList: ["wx-open-launch-weapp"]
        });

        if(callback) callback();

      })
    }
  } catch (e) {
    isSuccess = false;
  }
};


/**
 * 微信定位
 * @param callback  回调函数
 * @param return   返回经纬度信息
 */
export const wxGetPosition = (callback) => {
  let nn = false;
  wx.ready(function () {
    wx.getLocation({
      type: 'gcj02', // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
      success: function (res) {
        if(callback) callback(res);
        nn = true;
      },
      fail: function (res){
        res = { latitude: "", longitude: "" };
        if(callback) callback(res);
        nn = true;
      }
    });
  })

  setTimeout(function(){
    if(nn == false){
      let res = { latitude: "", longitude: "" };
      if(callback) callback(res);
      nn = true;
    }
  },5000);

};


/**
 * 微信定位成功后 返回城市编码信息
 * @param callback   回调函数 可返回当前用户所在经纬度
 */
export const getCityInfo = (callback) => {
  wxGetPosition(function(res){
    let obj ={ lat: res.latitude, lng: res.longitude };

    var scenicKey =  getStore("scenicKey").scenicKey || '';
    var headers = {
      'Content-Type': 'application/x-www-form-urlencoded'
    };
    if(scenicKey){
      headers = {
        'Content-Type': 'application/x-www-form-urlencoded',
        'scenicKey': scenicKey
      };
    }
    axios.post( getServer().admin + "getCityCode.do", Qs.stringify(obj), {
      headers: headers
    }).then(function (data) {
      if(data.data.errcode == "00000"){
        setStore("cityInfo",data.data.data);
      }else {
        let cityInfo = { citycode: "1", city: "全国", address: "" };
        setStore("cityInfo",cityInfo);
      }
      if(callback) callback(obj);
    })
  });
};


/**
 * 微信导航
 * @param callback   回调函数
 */
export const wxOpenMapLocation = (lat, lng, name, address) => {
  try {
    lat = parseFloat(lat);
    lng = parseFloat(lng);
    wx.openLocation({
      latitude: lat,    //23.099994,
      longitude: lng,     //113.324520,
      name: name,
      address: address,
      scale: 14
    });
  } catch (e) {
    window.location.href = " https://apis.map.qq.com/tools/routeplan/eword=" + name + "&epointx=" + lng + "&epointy=" + lat + "&navibutton=2?referer=myapp&key=OB4BZ-D4W3U-B7VVO-4PJWW-6TKDJ-WPB77";
  }
}


/**
 * 微信分享
 * @param title  标题
 * @param desc  分享信息
 * @param img   分享小图
 * @param link   产品链接
 * @param fn   回调函数
 */
export const wxShareme = (title,desc,img,link,fun) => {
  var url = location.href.split('index.html')[0];
  var imgs = img ==""?(url+"static/logo.jpg"):img;
  wx.ready(function () {
    wx.updateTimelineShareData({  //分享到朋友圈
      title: desc, // 分享标题
      link: url+"index.html#" + link, // 分享链接
      imgUrl: imgs, // 分享图标
      success: function () {
        // 用户确认分享后执行的回调函数
        if(fun) fun()
      },
      cancel: function () {
        // 用户取消分享后执行的回调函数
      }
    });

    wx.updateAppMessageShareData({ //分享给好友
      title: title, // 分享标题
      desc: desc, // 分享描述
      link: url+"index.html#" + link, // 分享链接
      imgUrl: imgs, // 分享图标
      success: function () {
        // 用户确认分享后执行的回调函数
        if(fun) fun()
      },
      cancel: function () {
        // 用户取消分享后执行的回调函数
      }
    });
  })
};


/**
 * 微信图片预览
 * @param curSrc  当前图片
 * @param srcList  图片数组
 */
export const wxImgPreview = (curSrc, srcList) => {
  //这个检测是否参数为空
  if (!curSrc || !srcList || srcList.length == 0) {
    return;
  }
  wx.previewImage({
    current: curSrc, // 当前显示图片的http链接
    urls: srcList // 需要预览的图片http链接列表
  });
};


/**
 * 调用微信支付
 */
export const handleWxpay = (self,options,callback) => {
  if(isweixin) {
    //options 是接口返回的wx的一些配置信息
    wxReadyToPay(self,options,callback)
  }else {
    self.$toast("请打开微信支付");
  }
};

export const isweixin = () => {
  const is_weixin = (function(){return navigator.userAgent.toLowerCase().indexOf('micromessenger') !== -1})();
  if(is_weixin){
    $(function(){
      return true;
    });
  }else{
    $(function(){
      return false;
    });
  }
};

export const wxReadyToPay = (self,options,callback) => {
  if (typeof WeixinJSBridge == "undefined"){
    if( document.addEventListener ){
      document.addEventListener('WeixinJSBridgeReady', onBridgeReady(self,options,callback), false);
    }else if (document.attachEvent){
      document.attachEvent('WeixinJSBridgeReady', onBridgeReady(self,options,callback));
      document.attachEvent('onWeixinJSBridgeReady', onBridgeReady(self,options,callback));
    }
  }else{
    onBridgeReady(self,options,callback);
  }
};

export const onBridgeReady = (self,options,callback) => {
  WeixinJSBridge.invoke(
    'getBrandWCPayRequest',
    options,
    function(res){
      //使用以上方式判断前端返回,微信团队郑重提示：res.err_msg将在用户支付成功后返回    ok，但并不保证它绝对可靠。
      switch(res.err_msg){
        case "get_brand_wcpay_request:ok": //支付成功
          self.$toast('支付成功')
          if(callback) callback(true)
          break;
        case "get_brand_wcpay_request:cancel": //支付取消
          self.$toast('取消支付')
          break;
        case "get_brand_wcpay_request:fail": //支付失败
          self.$toast('支付失败')
          break;
        default:
          self.$toast("支付失败");
          break;
      }
    }
  )
};


/**
 * 创建订单
 * @param self    指向this
 * @param obj  返回给前端的订单需要的信息
 * @param callback   回调函数
 */
export const creatOrder = (self,obj,callback) => {
  self.$loading.show('提交订单中');

  var url = 'rest/pay/order'; //包团提交订单
  if(self.productInfo && self.productInfo.type==2){
    if(self.ordernum1){
      url = 'rest/pay/canorder'; //参团提交订单
    }else {
      url = 'rest/pay/pinorder';  //发起拼团提交订单
    }
  }

  var scenicKey =  getStore("scenicKey").scenicKey || '';
  var headers = {
    'Content-Type': 'application/x-www-form-urlencoded'
  };
  if(scenicKey){
    headers = {
      'Content-Type': 'application/x-www-form-urlencoded',
      'scenicKey': scenicKey
    };
  }

  axios.post( getServer().admin + url, Qs.stringify(obj), {
    headers: headers
  }).then(function (data) {
    if(data.data.errcode == "00000"){
      let obj1 = {  }; //公众号发起支付
      axios.post( data.data.data, Qs.stringify(obj1), {
        headers: headers
      }).then(function (data) {
        self.$loading.hide();

        let param = data.data.data;
        if(param == 0){
          self.$toast('支付成功')
          if(callback) callback(true)
          return
        }else if (!param) {
          self.$toast("支付错误");
          return
        }else {
          //判断是否是在微信小程序环境
          param = JSON.parse(param)

          handleWxpay(self,param,callback)
        }
      })
      self.ordernum = data.data.data.split("code=")[1];
      console.log(self.ordernum);
    }else {
      self.$loading.hide();
      self.$toast(data.data.errmsg);
    }

  })
};


/**
 * 待支付订单立即支付
 * @param self    指向this
 * @param ordernum    订单编号
 * @param callback   回调函数
 */
export const payMoney = (self,ordernum,callback) => {
  var scenicKey =  getStore("scenicKey").scenicKey || '';
  var headers = {
    'Content-Type': 'application/x-www-form-urlencoded'
  };
  if(scenicKey){
    headers = {
      'Content-Type': 'application/x-www-form-urlencoded',
      'scenicKey': scenicKey
    };
  }

  let obj = { }; //公众号发起支付
  var url = getServer().admin+"rest/pay/getcode?code="+ordernum
  axios.post( url, Qs.stringify(obj), {
    headers: headers
  }).then(function (data) {
    let param = data.data.data;
    if(param == 0){
      self.$toast('支付成功')
      if(callback) callback(true)
      return
    }else if (!param) {
      self.$toast("支付错误");
      return
    }else {
      //判断是否是在微信小程序环境
      param = JSON.parse(param)

      handleWxpay(self,param,callback)
    }
  })
};


/**
 * 创建打赏订单
 * @param self    指向this
 * @param obj   需要购买的订单专辑包
 * @param callback   回调函数
 */
export const creatDSOrder = (self,obj,callback) => {
  var scenicKey =  getStore("scenicKey").scenicKey || '';
  var headers = {
    'Content-Type': 'application/x-www-form-urlencoded'
  };
  if(scenicKey){
    headers = {
      'Content-Type': 'application/x-www-form-urlencoded',
      'scenicKey': scenicKey
    };
  }

  self.$loading.show('提交订单中');
  axios.post( getServer().admin + "rest/pay/dsorder", Qs.stringify(obj), {
    headers: headers
  }).then(function (data) {

    if(data.data.errcode == "00000"){
      let obj1 = {  };
      axios.post( data.data.data, Qs.stringify(obj1), {
        headers: headers
      }).then(function (data)  {
        self.$loading.hide();

        let param = data.data.data;
        if (!param) {
          self.$toast("支付错误");
          return
        }else {
          //判断是否是在微信小程序环境
          param = JSON.parse(param)

          handleWxpay(self,param,callback)
        }
      })
    }else {
      self.$loading.hide();
      self.$toast(data.data.errmsg);
    }

  }).catch(function (data){
    self.$loading.hide();
    self.$toast(data.data.errmsg);

  })

};

//判断用户是否绑定电话号码
export const isPhonebind = (self,callback) => {
  var scenicKey =  getStore("scenicKey").scenicKey || '';
  var headers = {
    'Content-Type': 'application/x-www-form-urlencoded'
  };
  if(scenicKey){
    headers = {
      'Content-Type': 'application/x-www-form-urlencoded',
      'scenicKey': scenicKey
    };
  }

  var userInfo = getStore("userInfo");
  let obj = { openid: userInfo.openid };
  axios.post( getServer().admin + "/getUserPhone.do ", Qs.stringify(obj), {
    headers: headers
  }).then(function (data) {

    if(data.data.errcode == "00000" && data.data.data.phone){
      if(callback) callback(true)
    }else {
      self.$router.push({
        path: `/login`
      });
    }
  })
};


/**
 * 通用文件上传
 * @param imgs    图片数组
 * @param callback    回调函数
 */
export const uploadFile = (file,callback) =>{
  var scenicKey =  getStore("scenicKey").scenicKey || '';
  var headers = {
    'Content-Type': 'application/x-www-form-urlencoded'
  };
  if(scenicKey){
    headers = {
      'Content-Type': 'application/x-www-form-urlencoded',
      'scenicKey': scenicKey
    };
  }

  axios.post( getServer().admin + "upload.do", file, {
    headers: headers
  }).then(function (data) {
    if(callback) callback(data);
  })
};


/**
 * 上传评价
 * @param imgs    图片数组
 * @param callback    回调函数
 */
export const uploadCom = (bagid,info,score,imgs,callback) =>{
  let userInfo = getStore("userInfo");
  let obj = {
    openid: userInfo.openid,
    bagid: bagid,
    info: info,
    type: 0,
    score: score,
    img: imgs.toString(),
  };

  var scenicKey =  getStore("scenicKey").scenicKey || '';
  var headers = {
    'Content-Type': 'application/x-www-form-urlencoded'
  };
  if(scenicKey){
    headers = {
      'Content-Type': 'application/x-www-form-urlencoded',
      'scenicKey': scenicKey
    };
  }
  axios.post( getServer().admin + "comment.do", Qs.stringify(obj), {
    headers: headers
  }).then(function (data) {
    if(callback) callback(data);
  })
};


/**
 * 通用文件上传
 * @param file    图片文件
 * @param callback    回调函数
 */
export const uploadFile1 = (file,callback) =>{
  var scenicKey =  getStore("scenicKey").scenicKey || '';
  var headers = {
    'Content-Type': 'application/x-www-form-urlencoded'
  };
  if(scenicKey){
    headers = {
      'Content-Type': 'application/x-www-form-urlencoded',
      'scenicKey': scenicKey
    };
  }

  axios.post( getServer().admin + "rest/tool/upload2", file, {
    headers: headers
  }).then(function (data) {
    if(callback) callback(data);
  })
};






// WEBPACK FOOTER //
// ./src/utils/wechat.js